import { TranslationHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/helpers';
import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { Anything, PlanDetail } from '@types';

export const usePlans = (): PlanDetail[] => {
	// keep this hook here to update when translations obtained
	useTranslation();
	const plansResources = TranslationHelper.getByKey('iziBizi.plans');
	const plans: PlanDetail[] = (plansResources?.result as Anything) || [];
	return plans;
};
